import { apiGet } from "../../client";

export function getAppVersion() {
  return apiGet("/api/version/");
}
